import React, { useMemo, useEffect, useState } from "react"
import { useTable, useBlockLayout } from "react-table"
import { useSticky } from "react-table-sticky"

import styled from "styled-components"

import CheckedIcon from "../svg/check.inline.svg"

const Styles = styled.div`
  .table {
    border: 1px solid #ddd;
    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }
    .th,
    .td {
      padding: 5px;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #ddd;
      background-color: #fff;
      overflow: hidden;
      :last-child {
        border-right: 0;
      }
      text-align: center;
    }
    .th {
      font-family: "Open Sans", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      color: #091034;
    }
    .td {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Open Sans", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 150%;
      color: #091034;
      word-break: break-word;
    }
    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }
      .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
      }
      .footer {
        bottom: 0;
        box-shadow: 0px -3px 3px #ccc;
      }
      .body {
        position: relative;
        z-index: 0;
      }
      [data-sticky-td] {
        position: sticky;
      }
      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }
      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }
`

const Table = props => {
  let columnsStructure = props.headers.map(cert => {
    return {
      Header: cert.value,
      Footer: cert.value,
      accessor: cert.value,
    }
  })
  columnsStructure.unshift({
    Header: "",
    Footer: "",
    accessor: "subject",
    disableFilters: true,
    sticky: "left",
  })

  const finalData = props.data.map((subject, index) => {
    let resolvedSubject = {}
    for (let i = 0; i < props.headers.length; ++i) {
      const isChecked = (
        subject.certificatesIds ||
        subject.paymentFormatIds ||
        []
      ).includes(props.headers[i].id)
      resolvedSubject[props.headers[i].value] = (
        <CheckedIcon
          certId={props.headers[i].id}
          className={`${isChecked ? "checked-icon" : "not-checked"}`}
        />
      )
    }
    resolvedSubject["subject"] = subject.value
    return resolvedSubject
  })

  function changeChecked(subj, cert, index) {
    if (props.changeChecked) {
      props.changeChecked(subj, cert, index)
    }
  }

  const columns = useMemo(() => columnsStructure, [props.data, props.headers])
  const data = useMemo(() => finalData, [props.data, props.headers])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useBlockLayout,
    useSticky
  )

  return (
    <Styles>
      <div
        {...getTableProps()}
        className="table sticky col"
        style={{ maxHeight: "500px" }}
      >
        <div className="header">
          {headerGroups.map(headerGroup => (
            <div {...headerGroup.getHeaderGroupProps()} className="tr">
              {headerGroup.headers.map(column => (
                <div
                  {...column.getHeaderProps()}
                  className="th d-flex align-items-center justify-content-center"
                >
                  {column.render("Header")}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div {...getTableBodyProps()} className="body">
          {rows.map(row => {
            prepareRow(row)
            return (
              <div {...row.getRowProps()} className="tr">
                {row.cells.map(cell => (
                  <div
                    {...cell.getCellProps()}
                    className="td curs-P d-flex flex-wrap align-items-center justify-content-center"
                    onClick={() =>
                      changeChecked(
                        props.data.find(
                          sub => sub.value === cell.row.values.subject
                        ),
                        props.headers.find(
                          cert => cert.value === cell.column["Header"]
                        ).id,
                        cell.row.index
                      )
                    }
                  >
                    {cell.render("Cell")}
                  </div>
                ))}
              </div>
            )
          })}
        </div>
      </div>
    </Styles>
  )
}
export default Table
